module.exports = __webpack_public_path__ + "static/img/dnsd_logo.58eb4dc.c1b6048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dnsd_logo.58eb4dc.png
// module id = sG1j
// module chunks = 4